// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InvoiceableSelectController from "./invoiceable_select_controller"
application.register("invoiceable-select", InvoiceableSelectController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import QuestionnaireQuestionFormController from "./questionnaire_question_form_controller"
application.register("questionnaire-question-form", QuestionnaireQuestionFormController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)
